import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import SplashScreen from "../Splash";
import LoaderCstm from "../Loader";

const GameEnterRoute = ({ sessionLoader, loginLoader, children }) => {
  const { user, loading } = useSelector(({ Auth }) => Auth);
  if (user?._id) {
    if (!user.status === "pending") {
      return <Navigate to="/verify-otp" />;
    }
  }
  if (sessionLoader || loginLoader) {
    return <SplashScreen />;
  }
  if (!user?._id && !sessionLoader && !loginLoader && !loading) {
    return children;
  }
  if (user?._id && !sessionLoader && !loginLoader && !loading) {
    return <Navigate to="/game" />;
  } else {
    if (loading) {
      return <LoaderCstm />;
    } else {
      return <SplashScreen />;
    }
  }
};

export default GameEnterRoute;
